import { Weapon } from '../Weapon.js';
import { WEAPONS } from '../../../../config/constants.js';

/**
 * Arc Needle — fast, low-damage homing darts. High fire rate makes up for
 * low per-hit damage; the limited turn rate (mirrors BossBullet's homing
 * shards) means it still tracks the boss's wander/dash movement without
 * being an inescapable auto-hit. Needle count grows at level 3 and again
 * at level 5; at level 8 (capstone) needles gain a second hit. Since a
 * needle's `homing` keeps it locked onto the same `target` even after a
 * hit (see Projectile._steerToward), that second hit in practice usually
 * lands back on whatever it just hit rather than punching through to a
 * different enemy — burst DPS, not true multi-target pierce like Spirit
 * Lance's capstone.
 */
export class ArcNeedle extends Weapon {
  constructor() {
    super(WEAPONS.arcNeedle);
  }

  fire(origin, target, pool) {
    const dx = target.x - origin.x;
    const dy = target.y - origin.y;
    const dist = Math.hypot(dx, dy);
    if (dist === 0) return;

    const baseAngle = Math.atan2(dy, dx);
    const dmg = this.config.damage + Math.floor(this.level / 2);
    const turnRate = this.config.turnRate + this.level * 0.2;
    const needleCount = this.level >= 5 ? 3 : (this.level >= 3 ? 2 : 1);
    const hits = this.level >= 8 ? 2 : 1;
    const spread = 0.4;

    for (let i = 0; i < needleCount; i++) {
      const t = needleCount === 1 ? 0 : (i / (needleCount - 1)) * 2 - 1;
      const angle = baseAngle + t * spread;
      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(angle) * this.config.projectileSpeed,
        vy: Math.sin(angle) * this.config.projectileSpeed,
        radius: this.config.projectileRadius,
        damage: dmg,
        hits,
        lifetime: this.config.lifetime,
        color: this.config.color,
        homing: true,
        turnRate,
        target,
      });
    }
  }
}
